import Link from 'next/link'
import styled from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
`
export const TitleContainer = styled.div`
  max-width: 1224px;
  margin: 0 auto;
  padding: 0 100px;

  @media (max-width: 768px) {
    padding: 0 25px;
  }
`
export const Tile = styled(Link)`
  color: var(--brand-secondary);
  text-decoration: none;
  display: block;
`
export const RegionImage = styled.div`
  background-color: lightgrey;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 310px;
  border-radius: 20px;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    height: 160px;
  }
`
